import { defineMessages } from 'react-intl';

export default defineMessages({
    errorTitle: {
        id: 'ml.policychange.pa.veracityCheck.errorTitle',
        defaultMessage: 'Something went wrong processing additional details'
    },
    errorDescription: {
        id: 'ml.policychange.pa.veracityCheck.errorDescription',
        defaultMessage: 'Please try again.'
    },
    validateInformation: {
        id: 'ml.policychange.pa.veracityCheck.Validate Information',
        defaultMessage: 'Validate Information'
    }
});
